/**
 * Created by trpgw37 on 6/18/19.
 */
import React from 'react';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';
import Content from 'services/Content';
import { contentConverter } from 'services/Content';
import { savedAppUrl } from 'services/Externals';

const convertedContent = contentConverter.makeHtml(
  Content.HasAccountsDetailMessage
);

const HasUnfinishedApplication = () => (
  <ErrorPage summaryMessage="Complete your ">
    <a className="error-page-link" href={savedAppUrl}>
      saved new account application.
    </a>
    <div className="error-page-message">
      <span dangerouslySetInnerHTML={{ __html: convertedContent }} />
    </div>
  </ErrorPage>
);

export default HasUnfinishedApplication;
